import React, { useEffect, useState } from 'react';
import './user-list.css';
import DashboardLayout from '../dashboardLayout';
import {
	getAssignedUserListApi,
	getMasjidListApi,
} from '../../../api/adminApi';
import { useDispatch } from 'react-redux';
import { PulseLoader } from 'react-spinners';
import Pagination from '../../../components/common/Pagination';
import SelectInput from '../../../components/common/SelectInput';
import DownloadIcon from '../../../assets/images/download-icon.png';
import { fileDownloadApi } from '../../../api/Sessions';
import JSZip from 'jszip';
import FileSaver from 'file-saver';

const ItikaafAssignedList = () => {
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(true);
	const [loadingApi, setLoadingApi] = useState(true);
	const status = 'pending';
	const [listSize, setListsize] = useState(1);
	const [pageNumbers, setPageNumbers] = useState([]);
	const [limit, setLimit] = useState({ start: 1, end: 3 });
	const [page, setPage] = useState(1);
	const SIZE = 25;
	const [masjidValue, setMasjidValue] = useState(null);
	const [masjidData, setMasjidData] = useState([]);
	const masjidId =
		masjidValue || (masjidData?.length > 0 ? masjidData[0]._id : null);
	const [assignedUserList, setAssignedUserList] = useState([]);
	const [downloadLoading, setDownloadLoading] = useState(false);
	const [downloadAllLoading, setDownloadAllLoading] = useState(false);

	const handleChange = (event) => {
		setMasjidValue(event.target.value);
	};

	const getFloorPlanList = () => {
		dispatch(getMasjidListApi(setLoadingApi, setMasjidData));
	};

	useEffect(() => {
		setLoadingApi(true);
		getFloorPlanList();
	}, []);

	useEffect(() => {
		let value = parseInt(listSize / SIZE) + (listSize % SIZE > 0 ? 1 : 0);
		let pageNumbersArray = [];
		for (let i = 1; i <= value; i++) {
			pageNumbersArray.push(i);
		}
		setPageNumbers(pageNumbersArray);
	}, [listSize, loadingApi]);

	useEffect(() => {
		if (masjidId) getUserList();
	}, [page, masjidId]);

	const getUserList = () => {
		dispatch(
			getAssignedUserListApi(
				status,
				SIZE,
				setListsize,
				page,
				setLoading,
				masjidId,
				setAssignedUserList,
			),
		);
	};

	const downloadFile = async (url, filename) => {
		try {
			const response = await fetch(url, { mode: 'cors' });
			if (!response.ok) {
				throw new Error('Network response was not ok');
			}
			const blob = await response.blob();
			const blobUrl = window.URL.createObjectURL(blob);
			const link = document.createElement('a');
			link.href = blobUrl;
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			window.URL.revokeObjectURL(blobUrl);
		} catch (error) {
			console.error('Error downloading file:', error);
		}
	};

	const handleDownload = (item) => {
		if (!item.ithikaafIdCard?.fileKey) {
			alert('PDF not available');
			return;
		}
		setDownloadLoading(true);
		const filename = item.name ? `${item.name}-IDCard.pdf` : 'IDCard.pdf';
		downloadFile(fileDownloadApi(item?.ithikaafIdCard?.fileKey), filename);
		setDownloadLoading(false);
	};

	const handleDownloadAll = async () => {
		setDownloadAllLoading(true);
		const zip = new JSZip();
		const promises = assignedUserList.map(async (user, i) => {
			if (user.ithikaafIdCard?.fileKey) {
				const url = fileDownloadApi(user.ithikaafIdCard.fileKey);
				const response = await fetch(url, { mode: 'cors' });
				if (response.ok) {
					const blob = await response.blob();
					const filename = user.name
						? `${user.name}-IDCard.pdf`
						: `IDCard-${i}.pdf`;
					zip.file(filename, blob);
				}
			}
		});
		await Promise.all(promises);
		const content = await zip.generateAsync({ type: 'blob' });
		FileSaver.saveAs(content, 'Itikaaf-IDCards.zip');
		setDownloadAllLoading(false);
	};

	return (
		<DashboardLayout>
			{loadingApi ? (
				<div className='loading-table-wrapper'>
					<PulseLoader
						color='#0e5472'
						style={{ display: 'flex', justifyContent: 'center' }}
					/>
				</div>
			) : (
				<div className='container video-upload p-0 mt-0'>
					<div className='title-searchbar'>
						<h1>I'tikaf Assigned Seat list</h1>
						<div style={{ padding: '0 12px' }}>
							<div className='itakaaf-input'>
								<SelectInput
									label=''
									name='masjidValue'
									options={masjidData?.map((item) => ({
										value: item?._id,
										label: item?.name,
									}))}
									handleChange={handleChange}
									value={masjidValue || ''}
									error={''}
									placeHolder='Select Masjid'
								/>
							</div>
						</div>
					</div>
					<div className='flex table-lists'>
						{assignedUserList?.length > 0 && (
							<div className='btn-wrapper'>
								<button
									className='btn btn-primary'
									onClick={handleDownloadAll}
									disabled={downloadAllLoading}
								>
									{downloadAllLoading ? (
										<PulseLoader color='#fff' size={10} />
									) : (
										'Download All'
									)}
								</button>
							</div>
						)}
						<div className='flex-large'>
							<table className='table' style={{ border: '1px solid #e9ecef' }}>
								<thead>
									<tr>
										<th style={{ width: '30%' }}>Name</th>
										<th style={{ width: '15%' }}>Age</th>
										<th style={{ width: '30%' }}>Email</th>
										<th style={{ width: '25%' }}></th>
									</tr>
								</thead>
								{loading ? (
									<tr className='loading-tr'>
										<td colSpan='4'>
											<div className='loading-table-wrapper'>
												<PulseLoader
													color='#0e5472'
													style={{ display: 'flex', justifyContent: 'center' }}
												/>
											</div>
										</td>
									</tr>
								) : assignedUserList?.length > 0 ? (
									assignedUserList.map((item) => (
										<tbody key={item._id}>
											<tr>
												<td>{item?.name}</td>
												<td>{item?.age}</td>
												<td>{item?.email}</td>
												<td>
													<div
														className='button-div'
														onClick={() => handleDownload(item)}
													>
														{downloadLoading ? (
															<PulseLoader
																color='#0e5472'
																style={{
																	display: 'flex',
																	justifyContent: 'center',
																}}
															/>
														) : (
															<img
																src={DownloadIcon}
																alt='DownloadIcon'
																width={'20px'}
															/>
														)}
													</div>
												</td>
											</tr>
										</tbody>
									))
								) : (
									<tr>
										<td colSpan={4}>
											<h1 style={{ textAlign: 'center' }}>No data found</h1>
										</td>
									</tr>
								)}
							</table>
							<div className='customer_page'>
								<div className='pagination'>
									<Pagination
										setPage={setPage}
										limit={limit}
										pageNumbers={pageNumbers}
										setLimit={setLimit}
										page={page}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
		</DashboardLayout>
	);
};

export default ItikaafAssignedList;
